// Vendor libraries
import { createAction, props } from '@ngrx/store';
export const setFundChart = createAction('[Fund Chart] Set Fund Chart', props());
